const headers = {
  name: "Create Debit Note",
  navigate: {
    path: [
      {
        name: "Debit Notes",
        path: "/app/purchases/debit-notes",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;